(ns dashboard.views.questionnaire.components.title
  (:require [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]
            [dashboard.views.workbook-workspace.view :as workspace]
            [re-frame.core :as rf]))

(def -component-id :component/questionnaire-title)

(rf/reg-event-db
  ::set-edit
  (fn [db [_ id editing? edit-value]]
    (assoc-in db
              [-component-id id]
              (cond-> {:error nil
                       :editing? editing?
                       :saving-edit? false}
                edit-value (assoc :edit-value edit-value)))))

(rf/reg-event-fx
  ::submit-edit
  (fn [{db :db} [_ questionnaire-id]]
    (let [custom-name (get-in db [-component-id questionnaire-id :edit-value])]
      {:db (assoc-in db [-component-id questionnaire-id :saving-edit?] true)
       :http-xhrio {:method :put
                    :uri (str "/api/questionnaires/" questionnaire-id "/custom-name")
                    :params custom-name
                    :format http-config/transit-request-format
                    :response-format http-config/transit-response-format
                    :on-success [::set-custom-name questionnaire-id custom-name]
                    :on-failure [::set-error questionnaire-id]}})))

(rf/reg-event-db
  ::set-custom-name
  (fn [db [_ questionnaire-id custom-name]]
    (-> db
        (update -component-id dissoc questionnaire-id)
        (assoc-in [:questionnaires questionnaire-id :metadata :data :custom-name] custom-name))))

(rf/reg-event-db
  ::set-error
  (fn [db [_ questionnaire-id]]
    (update-in db
               [-component-id questionnaire-id]
               merge
               {:editing? false
                :error    "Failed to update."})))

(rf/reg-event-db
  ::set-edit-value
  (fn [db [_ questionnaire custom-name]]
    (assoc-in db
              [-component-id questionnaire :edit-value]
              custom-name)))

(rf/reg-sub
  ::editor-state
  (fn [db [_ questionnaire-id]]
    (get-in db [-component-id questionnaire-id])))

(defn title [questionnaire-id {:keys [custom-name filename url]}]
  (let [questionnaire-name (or custom-name filename)
        {:keys [editing? error saving-edit? edit-value]
         :or   {editing? false
                saving-edit? false}} @(rf/subscribe [::editor-state questionnaire-id])]
    [:div.is-flex.is-flex-direction-column.is-align-items-start
     [:div.level.py-0.my-0
      [:div.level-left
       (if editing?
         [:div.level-item.field.has-addons
          ;; Button to save the changes
          [:div.control>a.button.is-primary.is-rounded
           {:class    [(when saving-edit?
                         "is-loading")]
            :on-click (fn [_]
                        (rf/dispatch [::submit-edit questionnaire-id]))
            :title "Save questionnaire name"}
           "Save"]

          ;; Input field for editing the custom name
          [:div.control>input.input.pl-3
           {:on-key-down   (fn [e]
                             (when (= "Escape" (.-key e))
                               (rf/dispatch [::set-edit questionnaire-id false])
                               (.preventDefault e)))
            :type          "text"
            :placeholder   "Custom Name..."
            :default-value edit-value
            :on-change     (fn [e]
                             (rf/dispatch [::set-edit-value questionnaire-id (.. e -target -value)]))
            :style         {:min-width "24rem"}}]

          ;; Button to cancel editing the custom name
          (when-not saving-edit?
            [:div.control>a.button.is-danger.is-rounded
             {:on-click (fn [_]
                          (rf/dispatch [::set-edit questionnaire-id false]))
              :title "Discard questionnaire name edit"}
             [:span.icon>i.fas.fa-xmark]])]

         [:span.level-item.title.my-0.is-3
          questionnaire-name])

       ;; Show edit button if not already editing the name
       (when-not (or saving-edit? editing?)
         [:a.level-item.button.is-rounded.is-secondary
          {:on-click (fn [_]
                       (rf/dispatch [::set-edit questionnaire-id true questionnaire-name]))
           :title "Edit questionnaire name"}
          [:span.icon>i.fas.fa-pen-to-square]])

       [:a.level-item.button.is-rounded.is-secondary

        {:on-click (fn [_]
                     (rf/dispatch [::ui/push-modal
                                   {:ctx {:filename questionnaire-name
                                          :questionnaire-id questionnaire-id}
                                    :content-props {:style {:width "90vw" :height "90vh" :max-height "90vh" :padding 0}}
                                    :component workspace/workbook-modal}]))
         :title "Workbook"}
        [:span.icon>i.fas.fa-table]]

       (when error
         [:p.has-text-danger {:style {:height 0}} error])]]
     [:div.is-size-6 {:style {:overflow "hidden" :text-overflow "ellipsis" :white-space "nowrap" :max-width "800px"}}
      (cond
        url [:a {:href url
                 :target "_blank"
                 :title "Open questionnaire portal in a new tab"}
             url]
        (not custom-name) [:span filename])]]))
